import { createContext, useContext } from 'react';

export interface TenantRole {
  tenantId: string;
  tenantName: string;
  roleTypeId: string;
  role: 'owner' | 'admin' | 'member';
}

export interface Tenant {
  id: string;
  name: string;
  logo: string | null;
  createdBy: string;
  createdAt: string | Date;
  updatedBy: string;
  updatedAt: string | Date;
}

export interface RoleType {
  id: string;
  role: string;
  scope: string;
}

export interface ActiveTenantContextType {
  activeTenantId: string | null;
  activeTenant: TenantRole | null;
  activeTenantData: Tenant | null; // Full tenant object
  availableTenants: TenantRole[];
  roleTypes: RoleType[]; // Role types for permission checks
  setActiveTenantId: (tenantId: string) => void;
  isLoading: boolean;
  tenantChangedInOtherTab: boolean;
}

export const ActiveTenantContext = createContext<ActiveTenantContextType>({
  activeTenantId: null,
  activeTenant: null,
  activeTenantData: null,
  availableTenants: [],
  roleTypes: [],
  setActiveTenantId: () => {},
  isLoading: true,
  tenantChangedInOtherTab: false
});

export const useActiveTenant = () => {
  const context = useContext(ActiveTenantContext);
  if (!context) {
    throw new Error('useActiveTenant must be used within an ActiveTenantProvider');
  }
  return context;
};
